module.exports = __webpack_public_path__ + "static/media/OpenSans-Light.1bf71be1.ttf";